/**
 * Created by valerasiestov on 03.11.15.
 */


if (!window.module) {
    window.module = {};
}

module.select = (function () {
    "use strict";

    var list = [],
        cacheTemplate,
        templateDefault = '/server/select-template.html';

    function Select(selectObject, template) {

        var self = this,
            controls = {},
            handlers = {

                triggerEvent: function () {
                    var customEvent = document.createEvent("HTMLEvents");
                    customEvent.initEvent("change", true, true);
                    selectObject.dispatchEvent(customEvent);
                },

                getData: function () {
                    var data = controls.data = {
                            current: '',
                            list: []
                        },
                        options = selectObject.options,
                        count = options.length,
                        i;

                    
                    for (i = 0; i < count; i++) {
                        data.list.push({id: options[i].value, value: options[i].textContent || options[i].innerHTML});
                    }

                    if (selectObject.selectedIndex === -1) {

                        if (data.list.length) {
                            data.current = data.list[0].value;
                        }

                    } else {
                        data.current = data.list[selectObject.selectedIndex].value;
                    }

                    return data;
                },

                render: function () {
                    var data = handlers.getData(),
                        template = controls.template;

                    controls.container.innerHTML = Mustache.render(template, data);
                    selectObject.customObject = self;
                },

                selectContainerClick: function (event) {
                    event.stopPropagation();

                    var cl = this.classList,
                        selects,
                        count,
                        i;

                    if (event.target.getAttribute('data-id')) {
                        selectObject.value = event.target.getAttribute('data-id');
                        handlers.triggerEvent();
                        handlers.hide();
                    }
                    else {

                        selects = list;
                        count = selects.length;

                        for (i = 0; i < count; i++) {
                            if (selects[i] !== self) {
                                selects[i].hide();
                            }
                        }

                        if (cl.contains('active')) {
                            cl.remove('active');
                        } else {
                            cl.add('active');
                        }
                    }

                },

                hide: function () {
                    controls.container.classList.remove('active');
                },

                changeEvent: function () {
                    handlers.render();
                }
            };

        function getControls() {
            var fragment = document.createDocumentFragment(),
                div = document.createElement('div');

            div.innerHTML = template;

            controls.container = div.firstElementChild;

            while (div.firstElementChild) {
                fragment.appendChild(div.firstElementChild);
            }

            selectObject.parentNode.insertBefore(fragment, selectObject);

            controls.template = controls.container.innerHTML;
        }

        function setConfig() {
            handlers.render();
        }

        function setEventList() {
            controls.container.addEventListener('click', handlers.selectContainerClick, false);
            selectObject.addEventListener('change', handlers.changeEvent, false);
            self.hide = handlers.hide;
            self.render = handlers.render;
        }

        function init() {
            getControls();
            setConfig();
            setEventList();
        }

        init();

    }

    function setEventList() {
        document.addEventListener('click', function () {
            var count = list.length,
                i;

            for (i = 0; i < count; i++) {
                list[i].hide();
            }

        }, false)
    }

    function init(params) {
        var count = params.list.length,
            i;

        setEventList();

        if (!count) {
            return;
        }

        fetch(params.template)
            .then(function (response) {
                return response.text();
            })
            .then(function (template) {
                cacheTemplate = template;
                for (i = 0; i < count; i++) {
                    list.push(new Select(params.list[i], template));
                }
            });
    }

    function add(params) {

        function addFunction(template) {
            var selectsList,
                i,
                count;

            if (params.element.length) {
                selectsList = params.element;
                count = selectsList.length;

                for (i = 0; i < count; i++) {
                    list.push(new Select(selectsList[i], template));
                }

            } else {
                list.push(new Select(params.element, template));
            }


        }

        if (!cacheTemplate) {
            fetch(params.template || templateDefault)
                .then(function (response) {
                    return response.text();
                })
                .then(function (template) {

                    cacheTemplate = template;
                    addFunction(template)
                });
        } else {
            addFunction(cacheTemplate);
        }
    }

    return {
        init: init,
        add: add
    };

}());

window.addEventListener('DOMContentLoaded', function () {

    module.select.init({
        list: document.querySelectorAll('select'),
        template: '/server/select-template.html'
    });

}, false);
